import React from 'react';
import { FadeInUp } from './FadeInUp';
import { ShimmerButton } from './ShimmerButton';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCtaSection() {
  const handleCheckout = () => {
    trackAddToCart();
    // Direct Shopify checkout — skips cart
    window.location.href = 'https://www.zentori.cl/cart/50438059032822:1';
  };
  return <section className="py-20 px-5 pt-[20px] pb-[20px]" data-id="element-40">
      <div className="max-w-2xl mx-auto text-center" data-id="element-41">
        <FadeInUp data-id="element-42">
          <ShimmerButton onClick={handleCheckout} className="w-full text-lg md:text-2xl py-6 mb-5" data-id="element-43">
            Sí, quiero la Ruta B (Protocolo de Calma) — $4.990 🐾
          </ShimmerButton>

          <p className="text-slate-dark/60 font-medium text-sm md:text-base mb-8 tracking-wide" data-id="element-44">
            Acceso inmediato &bull; Pago Seguro &bull; 7 Días de Garantía
          </p>

          {/* Trust badge row */}
          <div className="flex flex-wrap gap-3 items-center justify-center" data-id="element-45">
            {/* Visa */}
            <div className="bg-white rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-46">
              <svg viewBox="0 0 750 471" className="h-5" fill="none" data-id="element-47">
                <path d="M278.198 334.228l33.36-195.763h53.358l-33.384 195.763H278.198z" fill="#1A1F71" data-id="element-48" />
                <path d="M524.307 142.687c-10.57-3.966-27.135-8.222-47.822-8.222-52.725 0-89.863 26.551-90.18 64.604-.634 28.141 26.485 43.845 46.754 53.185 20.77 9.536 27.77 15.636 27.77 24.17-.317 13.032-16.652 18.985-32.037 18.985-21.42 0-32.794-2.966-50.376-10.283l-6.902-3.113-7.519 43.845c12.507 5.467 35.638 10.199 59.673 10.454 56.062 0 92.425-26.187 92.862-66.884.317-22.27-14.016-39.215-44.8-53.185-18.652-9.072-30.078-15.099-30.078-24.267.317-8.258 9.703-16.834 30.712-16.834 17.567-.317 30.295 3.548 40.218 7.519l4.82 2.268 7.325-42.168z" fill="#1A1F71" data-id="element-49" />
                <path d="M661.615 138.465h-41.231c-12.773 0-22.332 3.478-27.94 16.218l-79.245 179.545h56.062l11.19-29.189h68.397l6.508 29.189h49.474l-43.215-195.763zm-65.927 126.408l28.09-73.14 4.503-12.844 7.83 12.844 16.33 73.14h-56.753z" fill="#1A1F71" data-id="element-50" />
                <path d="M232.903 138.465L180.663 271.96l-5.565-26.867c-9.703-31.107-39.93-64.921-73.744-81.822l47.822 170.64h56.379l83.826-195.446h-56.478z" fill="#1A1F71" data-id="element-51" />
                <path d="M131.92 138.465H46.459l-.634 3.966c66.878 16.152 111.16 55.128 129.495 101.932L156.72 155.318c-3.331-12.423-12.907-16.535-24.8-16.853z" fill="#F9A533" data-id="element-52" />
              </svg>
            </div>
            {/* Mastercard */}
            <div className="bg-white rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-53">
              <svg viewBox="0 0 152.407 108" className="h-5" fill="none" data-id="element-54">
                <circle cx="60.412" cy="54" r="48" fill="#EB001B" data-id="element-55" />
                <circle cx="91.995" cy="54" r="48" fill="#F79E1B" data-id="element-56" />
                <path d="M76.204 18.631a47.834 47.834 0 0 0-15.792 35.369A47.834 47.834 0 0 0 76.204 89.37a47.834 47.834 0 0 0 15.791-35.37 47.834 47.834 0 0 0-15.791-35.369z" fill="#FF5F00" data-id="element-57" />
              </svg>
            </div>
            {/* Mercado Pago */}
            <div className="bg-[#00B1EA] rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-58">
              <svg viewBox="0 0 80 20" className="h-3.5" fill="none" data-id="element-59">
                <text x="40" y="14.5" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.3" data-id="element-60">
                  Mercado Pago
                </text>
              </svg>
            </div>
            {/* Redcompra */}
            <div className="bg-[#E31E24] rounded-lg px-3 py-1.5 flex items-center justify-center shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-61">
              <svg viewBox="0 0 80 20" className="h-3.5" fill="none" data-id="element-62">
                <text x="40" y="14.5" textAnchor="middle" fill="white" fontSize="11" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.3" data-id="element-63">
                  Redcompra
                </text>
              </svg>
            </div>
            {/* Transferencia Bancaria */}
            <div className="bg-[#2D5F2D] rounded-lg px-3 py-1.5 flex items-center justify-center gap-1.5 shadow-[0_1px_4px_rgba(0,0,0,0.12)]" style={{
            maxHeight: 28
          }} data-id="element-64">
              <svg viewBox="0 0 20 20" className="h-3.5" fill="none" data-id="element-65">
                <rect x="3" y="4" width="14" height="2" rx="0.5" fill="white" data-id="element-66" />
                <rect x="5" y="7" width="2" height="7" fill="white" data-id="element-67" />
                <rect x="9" y="7" width="2" height="7" fill="white" data-id="element-68" />
                <rect x="13" y="7" width="2" height="7" fill="white" data-id="element-69" />
                <rect x="3" y="15" width="14" height="2" rx="0.5" fill="white" data-id="element-70" />
              </svg>
              <svg viewBox="0 0 80 20" className="h-3" fill="none" data-id="element-71">
                <text x="40" y="14" textAnchor="middle" fill="white" fontSize="10" fontWeight="700" fontFamily="Arial, Helvetica, sans-serif" letterSpacing="0.2" data-id="element-72">
                  Transferencia
                </text>
              </svg>
            </div>
          </div>
        </FadeInUp>
      </div>
    </section>;
}